import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Public API
export const fetchConfig = () => api.get("/config").then((r) => r.data);

export const createApplication = (payload) =>
  api.post("/applications", payload).then((r) => r.data);

export const uploadDocument = (applicationId, docKey, file, onProgress) => {
  const formData = new FormData();
  formData.append("doc_key", docKey);
  formData.append("file", file);
  return api
    .post(`/applications/${applicationId}/documents`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) {
          onProgress(Math.round((evt.loaded * 100) / evt.total));
        }
      },
    })
    .then((r) => r.data);
};

export const submitApplication = (applicationId) =>
  api.post(`/applications/${applicationId}/submit`).then((r) => r.data);

export const getApplication = (applicationId) =>
  api.get(`/applications/${applicationId}`).then((r) => r.data);

export const getApplicationByFolio = (folio) =>
  api.get(`/applications/folio/${folio}`).then((r) => r.data);

// Admin
const TOKEN_KEY = "eje_admin_token";
const EMAIL_KEY = "eje_admin_email";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getAdminEmail = () => localStorage.getItem(EMAIL_KEY);
export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
};

export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => {
    localStorage.setItem(TOKEN_KEY, r.data.access_token);
    localStorage.setItem(EMAIL_KEY, r.data.email);
    return r.data;
  });

const authHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const adminListApplications = (params = {}) =>
  api
    .get("/admin/applications", { headers: authHeaders(), params })
    .then((r) => r.data);

export const adminGetApplication = (id) =>
  api
    .get(`/admin/applications/${id}`, { headers: authHeaders() })
    .then((r) => r.data);

export const adminStats = () =>
  api.get("/admin/stats", { headers: authHeaders() }).then((r) => r.data);

export const adminFileUrl = (storagePath) => {
  const token = getToken();
  const qs = new URLSearchParams({ path: storagePath, auth: token || "" });
  return `${API}/admin/files/download?${qs.toString()}`;
};

export const adminCsvUrl = () => {
  const token = getToken();
  const qs = new URLSearchParams({ auth: token || "" });
  return `${API}/admin/applications/export.csv?${qs.toString()}`;
};
